import { Box } from "@mui/material";

const pillBase = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  px: 1.25,
  py: 0.35,
  borderRadius: 999,
  fontSize: "0.8125rem",
  fontWeight: 700,
  letterSpacing: "0.01em",
};

const RestaurantDealCountPills = ({
  activeCount = 0,
  inactiveCount = 0,
  sx: sxProp = {},
}) => {
  if (activeCount === 0 && inactiveCount === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
        mb: 2,
        ...sxProp,
      }}
    >
      {activeCount > 0 ? (
        <Box
          component="span"
          sx={{
            ...pillBase,
            bgcolor: "#d1fae5",
            color: "#065f46",
          }}
        >
          {activeCount} Active
        </Box>
      ) : null}
      {inactiveCount > 0 ? (
        <Box
          component="span"
          sx={{
            ...pillBase,
            bgcolor: "#fee2e2",
            color: "#991b1b",
          }}
        >
          {inactiveCount} Inactive
        </Box>
      ) : null}
    </Box>
  );
};

export default RestaurantDealCountPills;
